/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_Stat_OrdersInputs */

const tr_landing_cockpit_stat_orders = /** @type {(inputs: Landing_Cockpit_Stat_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sipariş akışı`)
};

const en_landing_cockpit_stat_orders = /** @type {(inputs: Landing_Cockpit_Stat_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`order flow`)
};

const de_landing_cockpit_stat_orders = /** @type {(inputs: Landing_Cockpit_Stat_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellfluss`)
};

const ru_landing_cockpit_stat_orders = /** @type {(inputs: Landing_Cockpit_Stat_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`поток заказов`)
};

/**
* | output |
* | --- |
* | "order flow" |
*
* @param {Landing_Cockpit_Stat_OrdersInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_stat_orders = /** @type {((inputs?: Landing_Cockpit_Stat_OrdersInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Stat_OrdersInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_stat_orders(inputs)
	if (locale === "de") return de_landing_cockpit_stat_orders(inputs)
	if (locale === "ru") return ru_landing_cockpit_stat_orders(inputs)
	return tr_landing_cockpit_stat_orders(inputs)
});